webpackJsonp([65182145508788],{

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Client = function Client(_ref) {
	  var client = _ref.client;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'client' },
	    _react2.default.createElement('img', { className: 'client__logo', src: client.logo.resolutions.src, title: client.name, alt: client.name })
	  );
	};
	
	var Clients = function Clients(_ref2) {
	  var clients = _ref2.clients;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'clients' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'clients__list' },
	      clients.map(function (client, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'clients__element', key: index },
	          _react2.default.createElement(Client, { client: client })
	        );
	      })
	    )
	  );
	};
	
	exports.default = Clients;
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.c599d6fa.jpg";

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/10.ebe94a68.jpg";

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/11.698cc8b0.jpg";

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/12.6b37d5b1.jpg";

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/13.509c700b.jpg";

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.208d5192.jpg";

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.302fda7a.jpg";

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.95690ed3.jpg";

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5.f353d166.jpg";

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/6.fe37f433.jpg";

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/7.bd2e0b7e.jpg";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/8.2d32b41d.jpg";

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/9.74fb9956.jpg";

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Helmet = __webpack_require__(26);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _Section = __webpack_require__(48);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Carousel = __webpack_require__(64);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Clients = __webpack_require__(90);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _organizacja = __webpack_require__(703);
	
	var _organizacja2 = _interopRequireDefault(_organizacja);
	
	var _ = __webpack_require__(660);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(665);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(666);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(667);
	
	var _8 = _interopRequireDefault(_7);
	
	var _9 = __webpack_require__(668);
	
	var _10 = _interopRequireDefault(_9);
	
	var _11 = __webpack_require__(669);
	
	var _12 = _interopRequireDefault(_11);
	
	var _13 = __webpack_require__(670);
	
	var _14 = _interopRequireDefault(_13);
	
	var _15 = __webpack_require__(671);
	
	var _16 = _interopRequireDefault(_15);
	
	var _17 = __webpack_require__(672);
	
	var _18 = _interopRequireDefault(_17);
	
	var _19 = __webpack_require__(661);
	
	var _20 = _interopRequireDefault(_19);
	
	var _21 = __webpack_require__(662);
	
	var _22 = _interopRequireDefault(_21);
	
	var _23 = __webpack_require__(663);
	
	var _24 = _interopRequireDefault(_23);
	
	var _25 = __webpack_require__(664);
	
	var _26 = _interopRequireDefault(_25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = [{ resolutions: { src: _2.default } }, { resolutions: { src: _4.default } }, { resolutions: { src: _6.default } }, { resolutions: { src: _8.default } }, { resolutions: { src: _10.default } }, { resolutions: { src: _12.default } }, { resolutions: { src: _14.default } }, { resolutions: { src: _16.default } }, { resolutions: { src: _18.default } }, { resolutions: { src: _20.default } }, { resolutions: { src: _22.default } }, { resolutions: { src: _24.default } }, { resolutions: { src: _26.default } }];
	
	var text = '<p><strong>CustomArt</strong> to wieloletnie <strong>do\u015Bwiadczenie w bran\u017Cy</strong>, kilkaset odbytych imprez od kameralnych koncert\xF3w po opraw\u0119 rozbudowanych konferencji zar\xF3wno <strong>w kraju jak i za granic\u0105</strong>. Pozw\xF3l, \u017Ce zaproponujemy ci <strong>kompleksowe rozwi\u0105zania</strong> na potrzeby twojego wydarzenia.</p>';
	
	var seo = 'CustomArt to wieloletnie doświadczenie w branży, kilkaset odbytych imprez od kameralnych koncertów po oprawę rozbudowanych konferencji zarówno w kraju jak i za granicą. Pozwól, że zaproponujemy ci rozwiązania dopasowane do potrzeb twojego wydarzenia.';
	
	var Organization = function Organization(props) {
	  var clients = props.data.allContentfulClientList.edges[0].node.clients;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Helmet2.default,
	      { title: 'Organizacja wydarze\u0144' },
	      _react2.default.createElement('meta', { name: 'description', content: seo })
	    ),
	    _react2.default.createElement(_Section2.default, {
	      isFirstSection: true,
	      title: 'ORGANIZACJA WYDARZE\u0143',
	      background: _organizacja2.default,
	      subtitle: text
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section__container', style: { padding: '100px 15px' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Zajmujemy si\u0119 ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'organizacj\u0105'
	        ),
	        ' wydarze\u0144 stricte muzycznych, przygotowaniem i opraw\u0105 integracji firmowych, konferencji, gal rozdania nagr\xF3d czy pokaz\xF3w mody. Jeste\u015Bmy w stanie przygotowa\u0107 od zera ciekaw\u0105 koncepcj\u0119 zar\xF3wno na przyj\u0119cie prywatne jak i na du\u017Ce wydarzenia firmowe. Poka\u017Cemy przyk\u0142ady nietypowych realizacji, zaproponujemy ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'rozwi\u0105zania'
	        ),
	        ' dopasowane do ciebie i twoich wymaga\u0144, a nast\u0119pnie z u\u015Bmiechem na twarzy zrealizujemy ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'show'
	        ),
	        '  w p\u0142ynny i profesjonalny spos\xF3b.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Zapraszamy do sk\u0142adania zapyta\u0144 wszystkich, kt\xF3rzy szukaj\u0105 ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'oryginalnych koncepcji'
	        ),
	        ' i poszukuj\u0105 firmy, kt\xF3ra zrealizuje bez problemu ich ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'naj\u015Bmielsze wizje '
	        ),
	        'zapewniaj\u0105c najwy\u017Cszy poziom i najlepszych artyst\xF3w. Je\u015Bli nie masz jeszcze ani pomys\u0142u, ani wytycznych \u2013 ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'napisz do nas'
	        ),
	        '. Nasza ekipa skontaktuje si\u0119 z tob\u0105, dopyta o niezb\u0119dne kwestie, zbada oczekiwania oraz zaproponuje ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'najlepsze rozwi\u0105zania'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(_Carousel2.default, { images: images }),
	    _react2.default.createElement(
	      'section',
	      { className: 'text-section', style: { padding: '100px 15px' } },
	      _react2.default.createElement(
	        'h2',
	        { className: 'text-section__title', style: { textAlign: 'center' } },
	        'Zuafali nam'
	      ),
	      _react2.default.createElement(_Clients2.default, { clients: clients })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center', padding: '30px 0' } },
	      _react2.default.createElement(_Button2.default, { type: 'yellow', label: 'Napisz do nas!', mailto: 'mailto:kontakt@customart.pl' })
	    ),
	    _react2.default.createElement('div', { style: { paddingTop: 100 } })
	  );
	};
	
	exports.default = Organization;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/organizacja.6aa81d30.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-organizacja-wydarzen-js-2bf623a82214ab90dafa.js